import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { BulkInputFilterViewButtonProps as Props } from './types';

export const BulkInputFilterViewButton = memo(
  ({ className, filter, count, ...buttonProps }: Props) => {
    return (
      <Button
        className={classnames('BulkInputFilterViewButton', className)}
        sx={SX.root}
        color="default"
        disabled={filter.comingSoon}
        variant="outlined"
        size="xsmall"
        startIcon={!count ? <Icon name="plus" size={16} /> : undefined}
        children={count ? 'View' : 'Add'}
        disableRipple
        {...buttonProps}
      />
    );
  }
);

BulkInputFilterViewButton.displayName = 'BulkInputFilterViewButton';
